import type { DateTime } from "luxon";
import type { FC } from "react";
import { MultiCommonDashboardBox } from "../../../components/Dashboard/CommonDashboardBox";
import { InHouseProgressChart } from "../../../components/UIToolkit/Graphs/ProgressChart/InHouseProgressChart";
import { useManagementCenterDownload } from "../hooks/useManagementCenterDownload";
import { useManagementCenterMultiStaffSatisfaction } from "../hooks/useManagementCenterMulti";

interface IProps {
	maxRows: number;
	width: string;
	selectedRegions: string[];
	handleItemDoubleClick: (departmentName: string) => void;
	startDate: DateTime;
	endDate: DateTime;
}

export const StaffSatisfactionChart: FC<IProps> = ({ maxRows, width, selectedRegions, handleItemDoubleClick, startDate, endDate }) => {
	const { data, isLoading } = useManagementCenterMultiStaffSatisfaction({ startDate, endDate });
	const { download } = useManagementCenterDownload({ graphName: "staff-satisfaction", startDate, endDate });
	const rawItems = data?.items || [];

	const items = (selectedRegions.length === 0 ? rawItems : rawItems.filter((item) => selectedRegions.includes(item.region))).map((item) => ({
		...item,
		title: `${item.department}, ${item.region}`,
		onDoubleClick: () => handleItemDoubleClick(item.department),
	}));

	return (
		<MultiCommonDashboardBox sx={{ display: "flex", flexDirection: "column", alignItems: "start", width }}>
			<InHouseProgressChart
				title="Staff Satisfaction"
				items={items}
				threshold={{
					warning: 80, // 80% of wanted (4/5 stars)
					error: 50, // 50% of wanted (2.5/5 stars)
				}}
				showViewAll={true}
				maxVisibleItems={maxRows}
				statTitle="Average"
				hideWanted
				isLoading={isLoading}
				onDownload={download}
			/>
		</MultiCommonDashboardBox>
	);
};
